const link = process.env.REACT_APP_SERVER_API_V2

const getDeleteUserImage = (id:number) => `${link}/user/${id.toString()}/image`

export default getDeleteUserImage
